// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sticky-sidebar {
  position: fixed;
  top: 0;       
  left: 0;       
  height: calc(100vh - 100px); 
  margin-top: 100px;
  z-index: 9999; 
  overflow-y: auto; 
  scrollbar-width: none !important;  
  -ms-overflow-style: none;
}


.sticky-sidebar::-webkit-scrollbar {
  display: none;
}

.sticky-sidebar::-webkit-scrollbar-thumb {
  border-radius: 10px;
}

.sticky-sidebar::-webkit-scrollbar-thumb:hover {
  background-color: #555; 
}

.sticky-sidebar {
  scrollbar-color: transparent transparent;

}



.sidebar-header-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
}


.sidebar-link.active {
  background-color: #16a085; 
  color: #ffffff;
  font-weight: bold; 
}

.user-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-bottom: 10px;
}

.username {
  color: #FFFFFF;
  font-size: 1.2em;
  text-align: center;
}

.sidebar-link {
  color: #ffffff;
  text-decoration: none;
  display: flex;
  align-items: center;
  font-weight: bold;
  transition: background-color 0.3s;
}

.sidebar-link:hover {
  background-color: #16a085;
  color: #ffffff !important;
  font-weight: bold; 
}

.arrow-icon {
  margin-left: auto;
  transition: transform 0.3s;
}

.sidebar-link:hover .arrow-icon {
  transform: translateX(5px); 
}

@media (max-width: 768px) {
  .sidebar {
    margin-bottom: 20px; 

  }
  .form-container {
    padding: 10px; 
  }
  .iTjbFX{
    width: 0px;
  }

}

.sidebar-content {
  overflow-y: scroll !important; 
  -ms-overflow-style: none !important;
  scrollbar-width: none !important; 
}

.sidebar-content::-webkit-scrollbar {
  display: none !important;
}




`, "",{"version":3,"sources":["webpack://./src/components/Resume/Page/Sidebar.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,wBAAwB;AAC1B;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;;AAE1C;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,mBAAmB;;EAErB;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;;AAEF;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["\r\n.sticky-sidebar {\r\n  position: fixed;\r\n  top: 0;       \r\n  left: 0;       \r\n  height: calc(100vh - 100px); \r\n  margin-top: 100px;\r\n  z-index: 9999; \r\n  overflow-y: auto; \r\n  scrollbar-width: none !important;  \r\n  -ms-overflow-style: none;\r\n}\r\n\r\n\r\n.sticky-sidebar::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.sticky-sidebar::-webkit-scrollbar-thumb {\r\n  border-radius: 10px;\r\n}\r\n\r\n.sticky-sidebar::-webkit-scrollbar-thumb:hover {\r\n  background-color: #555; \r\n}\r\n\r\n.sticky-sidebar {\r\n  scrollbar-color: transparent transparent;\r\n\r\n}\r\n\r\n\r\n\r\n.sidebar-header-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 10px 0;\r\n}\r\n\r\n\r\n.sidebar-link.active {\r\n  background-color: #16a085; \r\n  color: #ffffff;\r\n  font-weight: bold; \r\n}\r\n\r\n.user-image {\r\n  width: 80px;\r\n  height: 80px;\r\n  border-radius: 50%;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.username {\r\n  color: #FFFFFF;\r\n  font-size: 1.2em;\r\n  text-align: center;\r\n}\r\n\r\n.sidebar-link {\r\n  color: #ffffff;\r\n  text-decoration: none;\r\n  display: flex;\r\n  align-items: center;\r\n  font-weight: bold;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.sidebar-link:hover {\r\n  background-color: #16a085;\r\n  color: #ffffff !important;\r\n  font-weight: bold; \r\n}\r\n\r\n.arrow-icon {\r\n  margin-left: auto;\r\n  transition: transform 0.3s;\r\n}\r\n\r\n.sidebar-link:hover .arrow-icon {\r\n  transform: translateX(5px); \r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .sidebar {\r\n    margin-bottom: 20px; \r\n\r\n  }\r\n  .form-container {\r\n    padding: 10px; \r\n  }\r\n  .iTjbFX{\r\n    width: 0px;\r\n  }\r\n\r\n}\r\n\r\n.sidebar-content {\r\n  overflow-y: scroll !important; \r\n  -ms-overflow-style: none !important;\r\n  scrollbar-width: none !important; \r\n}\r\n\r\n.sidebar-content::-webkit-scrollbar {\r\n  display: none !important;\r\n}\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
